const ASSET_BASE_URL = '/assets/images';
export const getAssetUrl = (path) => `${ASSET_BASE_URL}/${path}`;
